import { makeAutoObservable } from 'mobx';
import { AuthorizationStatuses } from '../../../../../infrastructure/types/features/auth/auth-types';
import {
  LoadingStatus,
  SubmittingStatus,
} from '../../../../../../shared/infrastructure/types/common/common-types';

class StatusManager {
  private _status: AuthorizationStatuses;

  constructor() {
    makeAutoObservable(this, {});

    this._status = {
      loginForm: SubmittingStatus.UNTOUCHED,
      loginLoadingStatus: LoadingStatus.LOADED,
      verificationPrepare: LoadingStatus.LOADED,
      registerFormStatus: SubmittingStatus.UNTOUCHED,
      recoveryFormStatus: SubmittingStatus.UNTOUCHED,
      enterPhoneLoading: LoadingStatus.LOADED,
    };
  }

  get status(): AuthorizationStatuses {
    return this._status;
  }

  setLoginFormStatus(status: SubmittingStatus) {
    this._status.loginForm = status;
  }

  setLoginLoadingStatus(status: LoadingStatus) {
    this._status.loginLoadingStatus = status;
  }

  setRegisterFormStatus(status: SubmittingStatus) {
    this._status.registerFormStatus = status;
  }

  setRecoveryFormStatus(status: SubmittingStatus) {
    this._status.recoveryFormStatus = status;
  }

  setEnterPhoneLoadingStatus(status: LoadingStatus) {
    this._status.enterPhoneLoading = status;
  }
  setVerificationPrepareStatus(status: LoadingStatus) {
    this._status.verificationPrepare = status;
  }
}

export { StatusManager };
